import { ConsultantProfilesCompleteness } from "./Completeness";
import { ConsultantProfileDetail } from "./Detail";

export const pages = {
  "consultant-profiles.detail": ConsultantProfileDetail,
  "consultant-profiles.completeness": ConsultantProfilesCompleteness,
};
